import { urlAssistances } from '../../api/urls';
import {
  apiGet,
  apiPost,
  apiDelete,
} from '../../api/index';

export function fetchAll({
  subjectPeriodId,
  pageInfo = ({ page: 1, pageSize: 15 }),
  onSuccess,
  onError,
}) {
  return apiPost(`${urlAssistances}/${subjectPeriodId}/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchMy({
  subjectPeriodId,
  pageInfo = ({ page: 1, pageSize: 15 }),
  onSuccess,
  onError,
}) {
  return apiPost(`${urlAssistances}/${subjectPeriodId}/my`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetch({ id, onSuccess, onError }) {
  return apiGet(`${urlAssistances}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }

      if (onSuccess) onSuccess(res);

      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchFormDatas({ subjectPeriodId, onSuccess, onError }) {
  return apiGet(`${urlAssistances}/form-data/${subjectPeriodId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function saveAssistance({ payload, onSuccess, onError }) {
  return apiPost(`${urlAssistances}`, payload)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }

      if (onSuccess) onSuccess(res);

      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function updatePresenceStundent({
  assistanceId, payload, onSuccess, onError,
}) {
  return apiPost(`${urlAssistances}/${assistanceId}/update-presence`, payload)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }

      if (onSuccess) onSuccess(res);

      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function deleteAssistance(id, callback) {
  return apiDelete(`${urlAssistances}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}
